export const PRE_BID_DOCUMENTATION_LABELS = {
  DOCUMENTS: 'Document(s)',
  STATUS: 'Status',
};

export const DOCUMENT_REVIEW_STATUS = {
  REVIEW_DONE: 'Review done',
  NEEDS_REVIEW: 'Needs review',
};
